export function Footer() {

    return (
        <footer>
            <span>All Rights Reserved © <a href="https://sense-apps.com" >SenseApps</a> {new Date().getFullYear()}</span>
        </footer>
    )
}